@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@tab-h-spacing: 4px;
@label-h-padding: 10px;
@tab-border-width: 1px;
@file-tab: {
  flex-basis: auto;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-top: 3px solid transparent;
  margin: 0 ~'calc(@{label-h-padding} + @{tab-h-spacing} + @{tab-border-width})';
  cursor: pointer;
  min-width: fit-content;

  &:first-of-type {
    margin-left: ~'calc(16px + @{label-h-padding} + @{tab-h-spacing} + @{tab-border-width})';
  }
};

@selected-file-tab: {
  color: @tabs--file-tab-button--selected--text-color;
  background-color: @tabs--file-tab-button--selected--background-color;
  border-radius: 4px 4px 0 0;
  border-left: @tab-border-width solid @tabs--file-tab-button--selected--border-color;
  border-top: @tab-border-width solid @tabs--file-tab-button--selected--border-color;
  border-right: @tab-border-width solid @tabs--file-tab-button--selected--border-color;
  bottom: -1px;
  padding: 0 @label-h-padding;
  margin: 0 @tab-h-spacing;

  &:first-of-type {
    margin: 0 @tab-h-spacing 0 ~'calc(16px + @{tab-h-spacing})';
  }

  &:after {
    background: none;
  }
};

.base-tab-button {
  height: 40px;
  line-height: 34px;
  font-size: 14px;
  color: @tabs--tab-button--text-color;
}

.tab-button {
  position: relative;
  float: left;
  margin-right: 20px;
  cursor: pointer;

  &:first-of-type {
    margin-left: 16px;
  }

  &:hover {
    color: @tabs--tab-button--hover--text-color;
    &:disabled {
      color: @tabs--tab-button--text-color;
      cursor: not-allowed;
    }
  }

  &.selected {
    color: @tabs--tab-button--selected--text-color;

    &:after {
      content: '';
      height: 4px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      background: @tabs--tab-button--selected--after--background-color;
    }
  }
}

.file-tab-button {
  @file-tab();

  &.selected {
    @selected-file-tab();
  }
}

.wizard-stepper-button {
  @chevron-width: 8px;
  @chevron-line-width: 2px;
  @chevron-total-width: ~'calc(@{chevron-width} + @{chevron-line-width})';
  @chevron-h-padding: 10px;

  @wizard-height: 32px;
  @wizard-half-height: ~'calc(0.5 * @{wizard-height})';

  margin: 0 ~'calc(@{chevron-total-width} + @{chevron-h-padding})' 0 0;
  padding-right: @chevron-h-padding;
  background-color: @tabs--wizard-stepper-button--background-color;
  color: @tabs--wizard-stepper-button--text-color;
  height: @wizard-height;
  line-height: @wizard-height;
  position: relative;

  &:first-of-type {
    padding-left: 16px;
  }

  &:before {
    content: '';
    position: absolute;
    background-color: @tabs--wizard-stepper-button--background-color;
    height: @wizard-height;
    width: ~'calc(2 * @{chevron-total-width})';
    right: ~'calc(-2 * @{chevron-total-width})';
  }

  &.selected {
    color: @tabs--wizard-stepper-button--selected--before--text-color;

    &:before,
    &:after {
      content: '';
      position: absolute;
      background-color: transparent;
      right: ~'calc(-1 * @{chevron-total-width})';
    }

    &:before {
      border-top: @wizard-half-height solid @tabs--wizard-stepper-button--selected--before--border-color;
      border-bottom: @wizard-half-height solid @tabs--wizard-stepper-button--selected--before--border-color;
      border-right: @chevron-line-width solid @tabs--wizard-stepper-button--selected--before--border-color;
      border-left: @chevron-width solid @tabs--wizard-stepper-button--selected--before--left-border-color;
      width: @chevron-total-width;
    }

    &:after {
      border-top: @wizard-half-height solid @tabs--wizard-stepper-button--selected--after--border-color;
      border-bottom: @wizard-half-height solid @tabs--wizard-stepper-button--selected--after--border-color;
      border-left: @chevron-width solid transparent;
      height: @wizard-height;
      width: @chevron-width;
    }
  }

  &.selected ~ & {
    background-color: @tabs--wizard-stepper-button--selected-child--background-color;
    color: @tabs--wizard-stepper-button--selected-child--text-color;

    &:before {
      background-color: @tabs--wizard-stepper-button--selected-child--before--background-color;
    }
  }
}
